import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ProjectStateController } from '../services/project-state.js';
import { router } from '../services/router.js';
import '../components/shared/cp-page-subnav.js';

const WORK_TABS = [
  { label: 'Projekte', path: '/projects' },
  { label: 'Private Todos', path: '/todos' },
];

@customElement('cp-page-projects')
export class CpPageProjects extends LitElement {
  createRenderRoot() { return this; }

  private _projectState = new ProjectStateController(this);

  connectedCallback(): void {
    super.connectedCallback();
    router.addEventListener('route-changed', this._onRouteChanged);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    router.removeEventListener('route-changed', this._onRouteChanged);
  }

  private _onRouteChanged = (): void => {
    this.requestUpdate();
  };

  private _onAddProject(): void {
    this.dispatchEvent(new CustomEvent('project-add-request', {
      bubbles: true,
      composed: true,
    }));
  }

  private _renderEmptyState() {
    return html`
      <div class="cp-page-projects__empty">
        <p class="cp-page-projects__empty-text">Noch keine Projekte registriert</p>
        <button
          class="cp-page-projects__empty-action"
          @click=${this._onAddProject}
        >Projekt hinzufuegen</button>
      </div>
    `;
  }

  private _renderDashboard() {
    const project = this._projectState.activeProject;
    if (!project) {
      return html`
        <div class="cp-page-projects__no-selection">
          <p class="cp-page-projects__no-selection-text">Waehle ein Projekt aus den Tabs oben aus.</p>
        </div>
      `;
    }

    const params = router.getParams();
    if (params.specId) {
      return html`
        <cp-spec-detail
          .projectId=${project.id}
          .specId=${params.specId}
        ></cp-spec-detail>
      `;
    }

    return html`
      <cp-project-dashboard
        .projectId=${project.id}
        .projectName=${project.name}
        .projectPath=${project.path}
        .companyId=${project.company_id}
      ></cp-project-dashboard>
    `;
  }

  render() {
    const { projects, loadingState, error } = this._projectState;

    if (loadingState === 'loading' && projects.length === 0) {
      return html`
        <div class="cp-page">
          <p class="cp-page__placeholder">Lade Projekte...</p>
        </div>
      `;
    }

    if (error) {
      return html`
        <div class="cp-page">
          <p class="cp-page-projects__error">${error}</p>
        </div>
      `;
    }

    if (projects.length === 0) {
      return html`<div class="cp-page">${this._renderEmptyState()}</div>`;
    }

    return html`
      <div class="cp-page">
        <cp-page-subnav .tabs=${WORK_TABS} activePath="/projects"></cp-page-subnav>
        ${this._renderDashboard()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-projects': CpPageProjects;
  }
}
